import React, {useState} from 'react';
import Page from "../../Components/Page";
import {Breadcrumbs} from "../../Components/Breadcrumbs";
import {useServiceBase} from "../../Components/ReactTable/useServiceBase";
import {LoadingWrapper} from "../../Components/LoadingWrapper";
import {getNicelyFormattedNumber} from "../../../utils/formatUtil";
import ReactTable from "../../Components/ReactTable";
import Files from 'react-files';
import {makeApiCallPost} from "../../../Api/makeApiCall";
import {toast} from "react-toastify";
import {toastError, toastSuccess} from "../../../utils/toast";
import {faIcons} from "../../../utils/iconConstants";


const GeographyCensus = () => {
    const endpointUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/geographyCensus/`;
    const { loading, data, refreshData} = useServiceBase({ endpointUrl });
    const [uploading, setUploading] = useState(false);
    const numberFormatter = ({getValue}) => getNicelyFormattedNumber(getValue());
    const geographyCensusColumns = [
        {
            header: "Geography Id",
            sticky: "left",
            size: 120,
            accessorKey: "geographyId",
            filterable: true
        },
        {
            header: "Week Id",
            sticky: "left",
            accessorKey: "weekId",
            filterable: true
        },
        {
            header: "Population",
            sticky: "left",
            accessorKey: "population",
            cell: numberFormatter,
            filterable: true
        },
        {
            header: "Household",
            sticky: "left",
            accessorKey: "household",
            cell: numberFormatter,
            filterable: true
        }

    ]

    function uploadCsvPostCall(fileContents) {
        const data = {data: fileContents};
        const url = `${process.env.REACT_APP_EDP_API_BASE_URL}/geographyCensus/upload`;
        return makeApiCallPost(url, JSON.stringify(data));
    }

    const onFilesChange = (files) => {
        const fileReader = new FileReader();

        fileReader.onload = (loadedFiles) => {

            return uploadCsvPostCall(loadedFiles.target.result)
                .then((result) => {
                    if (result?.apiError) {
                        const errorDetail = result?.apiError?.response?.data?.detail
                        toastError(toast, `Upload failed: ${errorDetail}`);
                    } else {
                        refreshData()
                        toastSuccess(toast, 'Upload successful!')
                    }
                    setUploading(false);
                });
        };

        const file = files[0];
        setUploading(true);
        fileReader.readAsText(file);
    }

    return <Page breadCrumbs={<Breadcrumbs items={[{label: "Services"}, {label: "Geography"}, {label: "Geography Census"}]}/>} name={"Geography Census"} beta={true}>
        <LoadingWrapper loading={loading || uploading}>
            <div
                title={"Upload CSV"}>
                <Files
                    className={`${faIcons.upload} upload files-dropzone`}
                    onChange={onFilesChange}
                    // accepts={['.csv']}
                    multiple={false}
                    maxFiles={1}
                    maxFileSize={10*1024*1024*1024}
                    clickable
                >
                    <i/>
                </Files>
            </div>
            <ReactTable
                filterable
                data={data.data}
                columns={geographyCensusColumns}
                initialState={{ pagination: { pageSize: 10 }, sorting: [{ id: "geographyId", desc: false }] }}
                editModalAdditionalClass={"market-service-two-edit-modal"}
            />
        </LoadingWrapper>
    </Page>;
};

export default GeographyCensus;
